// 机构详情页
export default {
  count:0,
  data:[],
  title:''
}
